import { makeStyles } from 'tss-react/mui';

export const useCatalogCardStyles = makeStyles()((theme) => ({
  root: {
    '&:hover .catalog-card-checkbox': {
      display: 'inline-block',
    },
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
